import { render, staticRenderFns } from "./RedirectsForm.vue?vue&type=template&id=12827811&"
import script from "./RedirectsForm.vue?vue&type=script&lang=js&"
export * from "./RedirectsForm.vue?vue&type=script&lang=js&"
import style0 from "./RedirectsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports